// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseApp = {
  app: null,
};

const firebaseConfig = {
  apiKey: 'AIzaSyB38jl8m7Ava8LZH83qqsQ8LoJxw5bIBR0',
  authDomain: 'truecounsel.firebaseapp.com',
  databaseURL: 'https://truecounsel-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'truecounsel',
  storageBucket: 'truecounsel.appspot.com',
  messagingSenderId: '303250175875',
  appId: '1:303250175875:web:ae8d1e0fa8745a58e468b6',
  measurementId: 'G-NTZJ6Y2Q5Y',
};

// Initialize Firebase
export const firebaseInit = () => {
  const app = initializeApp(firebaseConfig);
  firebaseApp.app = app;
};

// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// export const firebaseConfig = {
//   apiKey: "AIzaSyAEJhpikKij1NKCV74vRR80O6E3gtMxFgs",
//   authDomain: "lawsigna.firebaseapp.com",
//   databaseURL: "https://lawsigna-default-rtdb.asia-southeast1.firebasedatabase.app",
//   projectId: "lawsigna",
//   storageBucket: "lawsigna.firebasestorage.app",
//   messagingSenderId: "615121967602",
//   appId: "1:615121967602:web:642e930b25822393b1b36b",
//   measurementId: "G-FG6NMWYNJK"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);